"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _reactIntl = require("react-intl");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LogInButton = function LogInButton() {
  return _react.default.createElement("a", {
    className: "btn btn-success rounded-0",
    href: "".concat(process.env.REACT_APP_AUTH_URL, "?redirect_uri=").concat(window.location)
  }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faSignInAlt,
    className: "mr-1"
  }), _react.default.createElement(_reactIntl.FormattedMessage, {
    id: "log_in"
  }));
};

var _default = LogInButton;
exports.default = _default;